<template>
  <v-container  class="mx-2">
    <v-row>
      <v-col cols="12" lg="7">
        <v-breadcrumbs
          class="pl-0 pt-0"
          :items="items"
        ></v-breadcrumbs>
        <h1 class="mb-2">{{ $route.meta.title }}</h1>
        <v-form>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Название"
                  solo
                  outlined
                  dense
                  hide-details
                  flat
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions class="pl-0">
              <div class="my-2">
                  <v-btn
                    large
                    color="success"
                    class="text-none"
                    dark
                  >
                    Сохранить
                  </v-btn>
                  <v-btn
                    large
                    class="ma-2 text-none"
                    outlined
                    dense
                    hide-details color="error"
                  >
                    Отменить
                  </v-btn>
              </div>
            </v-card-actions>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NewTypeAgent',
  data () {
    return {
      items: [
        {
          text: 'Агенты',
          disabled: false,
          href: '/agents',
        },
        {
          text: 'Новый тип агента',
          disabled: true,
          href: 'breadcrumbs_link_1',
        },
      ],
    };
  },
};
</script>

<style>

</style>
